@if (!isLoading()) {
  <div class="content">
    @if (shipments().length > 0) {
      <app-shipments-table [shipments]="shipments()" [columns]="columns()" />
    } @else {
      <div class="no-active-shipments">Du har inte några pågående returer.</div>
    }
  </div>
}
